//0空白 1金币,2头饰3 座驾,4 VIP,5 气泡 -1 开屏展示-2定制礼物 -3 定制座驾 -4 靓号 -5 banner展示 9 勋章 10 title展示
export var AttrConfigType;
(function (AttrConfigType) {
    AttrConfigType[AttrConfigType["Blank"] = 0] = "Blank";
    AttrConfigType[AttrConfigType["Coin"] = 1] = "Coin";
    AttrConfigType[AttrConfigType["Head"] = 2] = "Head";
    AttrConfigType[AttrConfigType["Car"] = 3] = "Car";
    AttrConfigType[AttrConfigType["VIP"] = 4] = "VIP";
    AttrConfigType[AttrConfigType["Bubble"] = 5] = "Bubble";
    AttrConfigType[AttrConfigType["Score"] = 6] = "Score";
    AttrConfigType[AttrConfigType["OpenScreen"] = -1] = "OpenScreen";
    AttrConfigType[AttrConfigType["CustomGift"] = -2] = "CustomGift";
    AttrConfigType[AttrConfigType["CustomCar"] = -3] = "CustomCar";
    AttrConfigType[AttrConfigType["BeautifulNumber"] = -4] = "BeautifulNumber";
    AttrConfigType[AttrConfigType["Banner"] = -5] = "Banner";
    AttrConfigType[AttrConfigType["Medal"] = 9] = "Medal";
    AttrConfigType[AttrConfigType["Bag"] = 8] = "Bag";
    AttrConfigType[AttrConfigType["Title"] = 10] = "Title";
})(AttrConfigType || (AttrConfigType = {}));
